//

import { removeSpecialCharactersAndJoinAsCamelCase } from 'app/utils/string/string-utils';

export const buildEventTypeComponents = (lookupOptions, descriptorLookupOptions, loadEntityData) => {
    return [
        {
            type: 'text',
            properties: { label: 'Name', name: 'name' },
            constraints: { required: true },
        },
        {
            type: 'scriptTypeahead',
            properties: {
                label: 'Pre-Script',
                name: 'preScript.id',
                valueField: 'id',
                filterBy: [
                    { field: 'active', op: '=', value: true },
                    { field: 'lastVersion.id', op: 'is not null' },
                ],
            },
        },
        {
            type: 'scriptTypeahead',
            properties: {
                label: 'Script',
                name: 'script.id',
                valueField: 'id',
                filterBy: [
                    { field: 'active', op: '=', value: true },
                    { field: 'lastVersion.id', op: 'is not null' },
                ],
            },
        },
        {
            type: 'text',
            properties: { label: 'BPMN Signal', name: 'bpmnSignal' },
        },
        {
            type: 'entityTypesTypeahead',
            properties: {
                label: 'Device Type',
                name: 'entityType',
                onChange: async evnt => {
                    const data = evnt.target.value;
                    loadEntityData(data?.id, 'lookupOptions');
                    return [evnt.target];
                },
                filterBy: [{ field: 'active', op: '=', value: true }],
                filterResults: records => records.filter(record => record.entityPrimaryIndexes && record.entityPrimaryIndexes.some(index => index.isUnique)),
            },
        },
        {
            type: 'typeahead',
            properties: {
                label: 'Default lookup attribute',
                name: 'lookupAttribute',
                options: lookupOptions,
                isVisible: data => data.entityType && !!lookupOptions?.length,
            },
        },
        {
            type: 'entityTypesTypeahead',
            properties: {
                label: 'Descriptor Type',
                name: 'descriptorType',
                onChange: async evnt => {
                    const data = evnt.target.value;
                    loadEntityData(data?.id, 'descriptorLookupOptions');
                    return [evnt.target];
                },
                filterBy: [{ field: 'active', op: '=', value: true }],
                filterResults: records => records.filter(record => record.entityPrimaryIndexes && record.entityPrimaryIndexes.some(index => index.isUnique)),
            },
        },
        {
            type: 'typeahead',
            properties: {
                label: 'Descriptor lookup attribute',
                name: 'descriptorLookupAttribute',
                options: descriptorLookupOptions,
                isVisible: data => data.descriptorType && !!descriptorLookupOptions?.length,
            },
        },
    ];
};
export const normalizeEventTypeData = data => {
    if (!data) {
        return null;
    }
    const { preScript, script, entityType, descriptorType } = data;
    let metadata = null;
    try {
        metadata = JSON.parse(data.metadata);
    } catch (e) {}
    return {
        ...data,
        script: script?.id,
        preScript: preScript?.id,
        metadata,
        entityType: entityType?.uri || null,
        descriptorType: descriptorType?.uri || null,
    };
};

export const normalizeEvents = (records) => records.map((e, index) => ({
    ...e,
    eventUniqueId: `${e.id}_${e.time}_index${index}`
}));

export const attributeIconSelect = (format, type) => {
    switch (format) {
        case 'none':
            if(type === 'number') return 'numeric';
            else if (type === 'boolean') return 'checkbox-marked';
            return 'text';
        case 'link':
            return 'link';
        case 'date':
            return 'calendar-blank';
        case 'json':
            return 'view-comfy';
        default:
            return '';
    }
};

export const buildAttributeMenu = (isIndexed) => {
    const menu = [
        { 
            name: 'Copy',
            icon: 'content-copy',
        },
        ...(!isIndexed ? [
            { name: 'divider' },
            { 
                name: 'Delete attribute',
                icon: 'delete',
                withConfirmation: true,
                confirmationModalProps: {
                    header: 'Delete Attribute',
                    message: 'Are you sure you want to delete the selected attribute?',
                    declineButtonText: 'Cancel',
                    confirmButtonText: 'Delete',
                },
            }
        ] : [])
    ];

    return menu;
};


export const buildEventTypeAttributeFilterDefinitions = (eventDataAttributes, opMap) => {

    if(!eventDataAttributes?.length) return [];

    const indexedAttributes = eventDataAttributes.filter(a => a?.state === 'created');
    const filterDefs = indexedAttributes.map(att => {
        const { label, type, attribute } = att || {};
        const name = removeSpecialCharactersAndJoinAsCamelCase(attribute);
        return {
            field: attribute,
            type,
            properties: { label, name, opSelector: true, opValue: opMap?.[name] }
        };
    })

    if (filterDefs?.length) {
        return [
            {
                field: 'displayText',
                type: 'displayText',
                properties: { text: 'User-defined filters', name: 'displayText' },
                style: {
                    color: 'rgba(255, 255, 255, 0.7)',
                },
                filter: false,
                sort: false,
            },
            ...filterDefs,
        ];
    }

    return [];

}
export const getAttributeFieldType = (attribute) => {
    const { format, type } = attribute || {};
    
    if (!format || format.toLowerCase() === 'none') {
        switch ((type || '').toLowerCase()) {
            case 'text':
                return 'Text';
            case 'number':
                return 'Number';
            case 'boolean':
                return 'True or False';
            default:
                return '';
        }
    } else {
        const lowerFormat = format.toLowerCase();
        if (lowerFormat === 'json') {
            return 'JSON';
        }
        const formatted = format.charAt(0).toUpperCase() + format.slice(1);
        return `${formatted}`;
    }
}